import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import HeroPatent from './HeroPatent';
import PatentSection from './PatentSection';

const Patent = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <HeroPatent />
            <PatentSection />
            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default Patent;
